<template>
  <Row class="-pointer-" :nav-titles="navTitles" height="43px">
    <Cell class="-full-border-" :text="false">
      <AvatarLoading />
      <p class="ajax__line -round-" :style="style" />
    </Cell>
    <Cell class="-full-border-" :text="true">
      <p class="ajax__line -round-" :style="style" />
    </Cell>
    <Cell class="-full-border-" :text="true">
      <p class="ajax__line -round-" :style="style" />
    </Cell>
    <Cell class="-full-border-" :text="true">
      <p class="ajax__line -round-" :style="style" />
    </Cell>
    <Cell class="-full-border-" :text="true">
      <p class="ajax__line -round-" :style="style" />
    </Cell>
  </Row>
</template>

<script>
import Row from '@/views/Rating/components/Table/Row';
import Cell from '@/views/Rating/components/Table/Cell';
import AvatarLoading from './AvatarLoading';
export default {
  components: {
    Row,
    Cell,
    AvatarLoading
  },
  props: {
    navTitles: {}
  },
  data: () => ({
    style: {
      width: '100%',
      height: '1em'
    }
  })
};
</script>
